import {IVanillaReaderBookmarkData} from '../VanillaReader/VanillaReaderModel';
import {IVanillaReaderUI} from './IVanillaReaderUI';
import {IVanillaReaderUiComponentController} from './IVanillaReaderUiComponentController';
import {VanillaReaderUI} from './VanillaReaderUI';
import {IVanillaReaderAppEvent_NAVIGATION_INTENT} from '../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap';

export interface VanillaReaderUiDialogBookmarksController extends IVanillaReaderUiComponentController, IVanillaReaderUI {
}

/**
 * # VanillaReaderUiDialogBookmarksController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogBookmarks` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiDialogBookmarks
 *
 * */
export class VanillaReaderUiDialogBookmarksController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogBookmarks.onBookmarkItemClicked(vanillaReaderUiContext._onDialogBookmarksItemClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogBookmarks.onBookmarkItemButtonClicked(vanillaReaderUiContext._onDialogBookmarkItemButtonClicked.bind(vanillaReaderUiContext));
    }

    _onDialogBookmarksItemClicked(navigationData: IVanillaReaderAppEvent_NAVIGATION_INTENT): void {
        if (navigationData.locator) {
            this.navigateTo(navigationData.locator.toString());
        }

        this.dialogBookmarks?.close();
    };

    _onDialogBookmarkItemButtonClicked(bookmark: IVanillaReaderBookmarkData): void {
        this.vanillaReaderAPI?.deleteBookmark(bookmark.locator);
        this.dialogBookmarks?.close();
    };
}
